<div [ngClass]="{'sidebar-active': app.sidebarActive}" class="flex">
    <div class="sidebar-next-right-block">
        <service-type-promotions *ngIf="activeMenu === menuEnum.AllPromotions"></service-type-promotions>
        <discounts-report *ngIf="activeMenu === menuEnum.DiscountsReport"></discounts-report>
        <customer-quest *ngIf="activeMenu === menuEnum.CustomerQuest"></customer-quest>
        <incentive-quest *ngIf="activeMenu === menuEnum.IncentiveQuest"></incentive-quest>
        <referral-report *ngIf="activeMenu === menuEnum.ReferralReport"></referral-report>
        <promo-budget *ngIf="activeMenu === menuEnum.PromoBudgets"></promo-budget>
        <promo-sponsor *ngIf="activeMenu === menuEnum.PromoSponsors"></promo-sponsor>
        <promotion-materials *ngIf="activeMenu === menuEnum.PromotionMaterials"></promotion-materials>
    </div>
</div>
